export function Snippet (pEditor, pHTML)
{
  this.queryOpenInsertSnippetDialogEnabled = (pButton, command) =>
  {
    return (pEditor.helpers.userJavascript.isSelected() ? true : ((BEditor.browser.isIE) ? true : pEditor.queryBasicCommandEnabled(pButton, command)));
  };


  this.queryInsertSnippetState = (pButton, command) => pEditor.helpers.userJavascript.isSelected();


  this.openInsertSnippetDialog = (pButton) =>
  {
    let userScriptIndex, anchorIndex;
    let str = '';

    pEditor.pDialog = (pButton && pButton.getDialog()) ? pButton.getDialog() : BEditor.Dialogs['Snippet'].dialog;

    if (!pEditor.pDialog)
    {
      return false;
    }

    pEditor.range.save();

    userScriptIndex = pEditor.helpers.userJavascript.getIndex();

    if (userScriptIndex != null)
    {
      str += '<script';
      str += ((pEditor.helpers.userJavascript.scripts[userScriptIndex].language) ? ' language="' + pEditor.helpers.userJavascript.scripts[userScriptIndex].language + '"' : '');
      str += ((pEditor.helpers.userJavascript.scripts[userScriptIndex].type) ? ' type="' + pEditor.helpers.userJavascript.scripts[userScriptIndex].type + '"' : '');
      str += ((pEditor.helpers.userJavascript.scripts[userScriptIndex].src) ? ' src="' + pEditor.helpers.userJavascript.scripts[userScriptIndex].src + '"' : '');
      str += '>' + pEditor.helpers.userJavascript.scripts[userScriptIndex].content + '</script>';
    }
    else
    {
      anchorIndex = pEditor.anchor.getAnchorIndex();

      if (anchorIndex != null)
      {
        str += '<a name="' + pEditor.anchor.allAnchors[anchorIndex].name + '"></a>'
      }
    }

    pEditor.pDialog.setReturnedParameters('htmlContent', str);
    pEditor.pDialog.setReturnedParameters('userScriptIndex', userScriptIndex);
    pEditor.pDialog.setReturnedParameters('anchorIndex', anchorIndex);

    pEditor.pDialog.openWindow(function() { pEditor.pThis.execCommand(pButton, 'insertSnippet'); }, function() { pEditor.closeDialog(pEditor.pDialog); });

    pEditor.afterOpenDialog();
  };


  function insertSnippet (pButton)
  {
    let snippetHTML;
    let pParameters;

    if (pEditor.pDialog)
    {
      pParameters = pEditor.pDialog.getReturnedParameters();

      if (pParameters)
      {
        snippetHTML = (pParameters.htmlContent) ? pParameters.htmlContent : '';
        pEditor.closeDialog();
        snippetHTML = pEditor.anchor.fixLinksToAnchors(snippetHTML);

        if (pParameters.userScriptIndex != null)
        {
          pEditor.helpers.userJavascript.scripts[pParameters.userScriptIndex] = null;
        }

        if (snippetHTML.trim() != '')
        {
          pEditor.contentChecker.confirmClearMsHTML(insertSnippetStep1, snippetHTML);
        }
      }
    }
  }


  function insertSnippetStep1 (snippetHTML, isChanged)
  {
    if (isChanged || !pEditor.isTidyServiceOn)
    {
      insertSnippetStep2(snippetHTML);
    }
    else
    {
      BEditor.EditorsManager.showPageShadingContainer(true, 'Cleaning HTML...', 1000);
      pEditor.contentChecker.setExcludeWordCheck();
      pEditor.repairAndCleanHtml(snippetHTML, insertSnippetStep2);
    }
  }


  function insertSnippetStep2 (snippetHTML)
  {
    if (snippetHTML != null)
    {
      snippetHTML = pEditor.helpers.userJavascript.collect(snippetHTML, false, true);
      snippetHTML = pEditor.anchor.collectAnchors(snippetHTML, true);
      snippetHTML = pEditor.contentCleaner.clearHTML(snippetHTML);

      if (snippetHTML.trim() != '')
      {
        pEditor.helpers.insertHTML(snippetHTML);
      }
    }

    BEditor.EditorsManager.hidePageShadingContainer();
  }


  this.insertSnippet = insertSnippet;
}